import { createAction, props } from '@ngrx/store';
import * as authActions from './auth.actions'
import { AdminCountry, AuthUser, CompanyProfile } from './auth.interface';

export const login = createAction(
    '[Auth Module] login user',
    props<{ credentials: { email: string, password: string } }>()
);

export const loginSuccessful = createAction(
    '[Auth Module] login successful'
);

export const loginFailed = createAction(
    '[Auth Module] login failed',
    props<{message: string, code: number}>()
);


export const logout = createAction(
    '[Auth Module] logout'
);

